import { FaRegHandshake, FaTachometerAlt, FaLightbulb } from "react-icons/fa";

export const MISSION_CARDS_DATA = [
  {
    id: 1,
    Icon: FaTachometerAlt,
    title: "Precisione & Eccellenza",
    description:
      "Obiettivo primario è soddisfare le aspettative del cliente con la massima qualità e attenzione ai dettagli.",
  },
  {
    id: 2,
    Icon: FaLightbulb,
    title: "Aggiornamento Tecnologico",
    description:
      "Sentiamo l'esigenza di affinarci e di stare al passo con la tecnologia e le nuove metodologie di sviluppo.",
  },
  {
    id: 3,
    Icon: FaRegHandshake,
    title: "Trasparenza e Lealtà",
    description:
      "I nostri valori fondamentali che garantiscono un rapporto di fiducia e collaborazione duraturo con i clienti.",
  },
];